export default "__VITE_ASSET__8abf051e__"